import {Component} from '@angular/core';
import {DialogConfig} from '../../../../shared/modules/dialog/dialog-config';
import {DialogRef} from '../../../../shared/modules/dialog/dialog-ref';
import {Course, User} from '../../../../shared/models';
import {CourseService} from '../../../../shared/services';
import {Router} from '@angular/router';

@Component({
  selector: 'app-no-access-dialog',
  templateUrl: './no-access-dialog.component.html'
})
export class NoAccessDialogComponent {
  user: User;
  course: Course;
  loading: boolean;

  enrolling: boolean = false;

  constructor(public config: DialogConfig,
              public dialog: DialogRef,
              private courseService: CourseService,
              private router: Router) {
    this.user = config.data.user;
    this.course = config.data.course;
  }

  close(data: any = null): void {
    this.dialog.close(data);
  }

  enrollCourse(): void {
    this.enrolling = true;
    this.courseService.enroll(this.course.id).subscribe(resp => {
      this.enrolling = false;
      this.close();
      if (resp.success) {
        this.router.navigate(['/player/' + this.course.id]).finally();
      }
    }, () => {
      this.router.navigate(['/not-found']).finally();
    });
  }
}
